module.exports = __webpack_public_path__ + "static/media/YM17_2.91aa05ab.jpg";